import * as tslib_1 from "tslib";
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { ApprovalsEquipmentsApi } from './api/approvals-equipments-api.service';
import * as i0 from "@angular/core";
import * as i1 from "./api/approvals-equipments-api.service";
import * as i2 from "../../../../@fuse/components/progress-bar/progress-bar.service";
var ApprovalsEquipmentsService = /** @class */ (function () {
    function ApprovalsEquipmentsService(api, fuseProgressBarService) {
        this.api = api;
        this.fuseProgressBarService = fuseProgressBarService;
    }
    ApprovalsEquipmentsService.prototype.loadData = function (_a) {
        var where = _a.where, options = _a.options;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                this.fuseProgressBarService.show();
                return [2 /*return*/, this.api
                        .listApprovalsEquipments({
                        orderBy: options.orderBy,
                        limit: options.limit,
                        offset: options.offset,
                        where: where
                    })
                        .toPromise()
                        .then(function (data) {
                        _this.fuseProgressBarService.hide();
                        return {
                            items: data.items,
                            totalCount: data.totalCount,
                            filtered: Boolean(!!where.name_contains ||
                                !!where.number_contains ||
                                !!where.equipmentType_in ||
                                !!where.location_in ||
                                !!where.company_in ||
                                _this.verifyStatusFiltered(where))
                        };
                    })];
            });
        });
    };
    ApprovalsEquipmentsService.prototype.verifyStatusFiltered = function (where) {
        if (where.status_in) {
            return !(where.status_in.includes('pending') && where.status_in.length === 1);
        }
        return true;
    };
    ApprovalsEquipmentsService.prototype.getApprovalAndEquipment = function (_a) {
        var approvalId = _a.approvalId, equipmentQrCode = _a.equipmentQrCode;
        return this.api.getApprovalAndEquipment({
            approvalId: approvalId,
            equipmentQrCode: equipmentQrCode
        });
    };
    ApprovalsEquipmentsService.prototype.searchEquipment = function (number) {
        return this.api.searchEquipment({
            number_eq: number
        });
    };
    ApprovalsEquipmentsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ApprovalsEquipmentsService_Factory() { return new ApprovalsEquipmentsService(i0.ɵɵinject(i1.ApprovalsEquipmentsApi), i0.ɵɵinject(i2.FuseProgressBarService)); }, token: ApprovalsEquipmentsService, providedIn: "root" });
    return ApprovalsEquipmentsService;
}());
export { ApprovalsEquipmentsService };
